import React from 'react'

import { FormsElementTypeEnum, ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, FormEditor } from 'modules/forms'
import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'

import NewFormEditor from 'modules/procurement/components/procurementTypes/Form/NewFormEditor'

const PERMITTED_FIELD_TYPES: FormsElementTypeEnum[] = [
  'longtext',
  'multiselect',
  'number',
  'section',
  'select',
  'text',
  'url',
  'dropdownsingle',
  'date',
]

interface FormEditorProps {
  isNewFormEditorEnabled: false
  requestType: ProcurementTypeItemFragment
  form?: Form
  setForm: (form: Form) => void
}

interface NewFormEditorProps {
  isNewFormEditorEnabled: true
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
}

type Props = FormEditorProps | NewFormEditorProps

const FormTab = (props: Props) => {
  if (!props.isNewFormEditorEnabled) {
    if (!props.form) {
      return null
    }
    return (
      <FormEditor
        form={props.form}
        setForm={props.setForm}
        permittedFieldTypes={PERMITTED_FIELD_TYPES}
        showElementName={false}
        titleSize="small"
        defaultMandatory
      />
    )
  }

  return <NewFormEditor state={props.state} setState={props.setState} />
}

export default FormTab
